<template>
  <a-config-provider :locale="locale">
    <div id="app" class="theme1">
      <router-view/>
    </div>
  </a-config-provider>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
export default {
  name: 'App',
  data(){
    return {
      locale: zh_CN
    }
  }
}
</script>

<style lang="less">
@import './assets/less/base.less';
@import './assets/less/custom.less';
@import './assets/less/theme.less';
//@import './assets/font.less';
.theme1{
  .theme(@background_color:#fff;@btn_primary_color:#4CA3B6;);
}

#app {
  font-family: 'Avenir', Helvetica, Arial, Alibaba PuHuiTi, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
</style>
